//@flow
import React from 'react';
import DiningMenu from 'components/organisms/diningMenu';
import DiningMenuMobile from 'components/organisms/diningMenuMobile';
import { useViewport } from 'components/templates/viewportProvider';

type Props = {
  data: Array<RestaurantCategory>,
};

export const DiningMenuSection = (props: Props) => {
  const { isMobile } = useViewport();
  const { data } = props;
  if (!data.restaurantCategories.length) {
    return null;
  }

  return (
    <div id={'menu'}>
      {isMobile ? <DiningMenuMobile data={data} /> : <DiningMenu data={data} />}
    </div>
  );
};
